<template>
  <v-container
    id="eligibilityTab"
    class="pa-0"
  >
    <base-resource-grid
      color="green"
      icon="mdi-trophy-award"
      plural-name="Eligibility"
      singular-name="Eligibility"
      allow-expand
      :headers="gridHeaders"
      :resource="eligibilityResource"
      :fetch-method="getEligibility"
      :actions="actions"
      :prepare-save="prepareSave"
      :disabled="disabled"
      :sort-by="['orderNo']"
      @handleAction="handleAction"
      @item:updated="itemChanged"
      @item:added="itemChanged"
      @item:deleted="itemChanged"
    >
      <template
        v-slot:editForm="bindings"
        class="pa-0"
      >
        <eligibility-edit
          class="pa-0"
          :open-enrollment="openEnrollment"
          :edited-item.sync="bindings.editedItem"
          :form-errors="bindings.formErrors"
          :disabled="disabled"
        />
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="oeEligibilityHistory/"
      id-field="oeEligibilityId"
      title-field="Eligibility"
      color="green"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'EligibilityTab',

    components: {
      EligibilityEdit: () => import('./EligibilityEdit'),
    },

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      gridHeaders: [
        {
          text: 'Product',
          value: 'product',
        },
        {
          text: 'Carrier',
          value: 'carrier',
        },
        {
          text: 'Eligibility Group',
          value: 'eligibilityGroup',
        },
        {
          text: 'Order',
          value: 'orderNo',
        },
      ],

      historyColumns: [
        {
          text: 'Product',
          value: 'product',
        },
        {
          text: 'Carrier',
          value: 'carrier',
        },
        {
          text: 'Eligibility Group',
          value: 'eligibilityGroup',
        },
        {
          text: 'Retroactive Enrollments Allowed',
          value: 'retroactiveEnrollmentsAllowed',
          dataType: 'boolean',
        },
        {
          text: 'Domestic Partners Allowed',
          value: 'eligibleForCoverage',
          dataType: 'boolean',
        },
        {
          text: 'COBRA Eligible',
          value: 'cobraEligible',
          dataType: 'boolean',
        },
        {
          text: 'Min Hours',
          value: 'minHours',
        },
        {
          text: 'Waiting Period',
          value: 'waitingPeriod',
        },
        {
          text: 'Grace Period',
          value: 'gracePeriod',
        },
        {
          text: 'Effective Mode',
          value: 'effectiveMode',
        },
        {
          text: 'Effective Date',
          value: 'effectiveDate',
        },
        {
          text: 'Term Mode',
          value: 'termMode',
        },
        {
          text: 'Tax Status',
          value: 'taxStatus',
        },
        {
          text: 'New Hires Can Enroll Throughout Year',
          value: 'newHiresCanEnrollThroughoutYear',
          dataType: 'boolean',
        },
        {
          text: 'Require Dep SSN',
          value: 'requireDepSSN',
          dataType: 'boolean',
        },
        {
          text: 'Payroll Deduction Mode',
          value: 'payrollDeductionMode',
        },
        {
          text: 'Employee First Deduction Mode',
          value: 'employeeFirstDeductionMode',
        },
        {
          text: 'Bill',
          value: 'bill',
        },
        {
          text: 'Order',
          value: 'orderNo',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      eligibilityResource: new TroodyApi('oeEligibility/'),

      historyItem: null,
    }),

    methods: {
      getEligibility () {
        return this.eligibilityResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
      },

      prepareSave (payload) {
        if (payload) {
          payload.openEnrollmentId = this.openEnrollment.id
        }
        return payload
      },
    },
  }
</script>
